/**
 * @flow
 * @relayHash a3db9d49adf6b2b3dc6f8bfa0468ba62
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CSVImportStatus = "COMPLETED" | "FAILED" | "IMPORTING" | "MAPPING" | "UPLOADING" | "VALIDATING";
export type ExecuteCSVImportInput = {|
  csvImportId: string
|};
export type ExecuteCSVImportMutationVariables = {|
  input: ExecuteCSVImportInput
|};
export type ExecuteCSVImportMutationResponse = {|
  +executeCSVImport: {|
    +csvImport: {|
      +csvImportId: string,
      +status: CSVImportStatus,
      +importedCount: ?number,
      +updatedCount: ?number,
      +skippedCount: ?number,
      +skippedDetails: ?any,
      +errorMessage: ?string,
    |}
  |}
|};
export type ExecuteCSVImportMutation = {|
  variables: ExecuteCSVImportMutationVariables,
  response: ExecuteCSVImportMutationResponse,
|};
*/


/*
mutation ExecuteCSVImportMutation(
  $input: ExecuteCSVImportInput!
) {
  executeCSVImport(input: $input) {
    csvImport {
      csvImportId
      status
      importedCount
      updatedCount
      skippedCount
      skippedDetails
      errorMessage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ExecuteCSVImportInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "executeCSVImport",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ExecuteCSVImportPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "csvImport",
        "storageKey": null,
        "args": null,
        "concreteType": "CSVImport",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "csvImportId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "importedCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "updatedCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "skippedCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "skippedDetails",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "errorMessage",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ExecuteCSVImportMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ExecuteCSVImportMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "ExecuteCSVImportMutation",
    "id": null,
    "text": "mutation ExecuteCSVImportMutation(\n  $input: ExecuteCSVImportInput!\n) {\n  executeCSVImport(input: $input) {\n    csvImport {\n      csvImportId\n      status\n      importedCount\n      updatedCount\n      skippedCount\n      skippedDetails\n      errorMessage\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '47526dcc6b570d8acc005440ca39fd68';
module.exports = node;
